/**
 * Given our app Node, determine if it's in one of the larger NXS widget areas.
 * @param {Node} hub - react data node for hub.
 * @returns {boolean} if is in widget area, true, else false.
 */
export default function isInNXSWidgetArea(hub) {
  // Bail if no hub node.
  if (! hub) {
    return false;
  }

  // Predefined widget area wrappers for NXS themes.
  const widgetLocation = [
    '.zone-container--below-supernav', // Below nav.
    '.zone-container--above-hero', // Above header.
    '.site-content__layout >', // Above content.
  ];

  // Loop through areas and check to see if current hub is in that area.
  const isInWidgetArea = widgetLocation.reduce((acc, location) => {
    // Return value if true.
    if (acc) {
      return acc;
    }

    // Query location.
    const widgetArea = document.querySelector(
      `${location} .widget_election-hub .election-hub-widget`
    );

    // Assume we return a value.
    if (widgetArea) {
      // Check if our hub is in the container.
      return widgetArea.contains(hub);
    }

    return acc;
  }, false);

  // Return single bool.
  return isInWidgetArea;
}
